import { render, staticRenderFns } from "./accountsCost.vue?vue&type=template&id=a912ac5a&scoped=true&"
import script from "./accountsCost.vue?vue&type=script&lang=js&"
export * from "./accountsCost.vue?vue&type=script&lang=js&"
import style0 from "./accountsCost.vue?vue&type=style&index=0&id=a912ac5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a912ac5a",
  null
  
)

export default component.exports